import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';
import { SubProject } from 'src/app/model/project/sub-project';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import { CollectionHelper } from 'src/app/helpers/collection-helper';

@Component({
  selector: 'quotation-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuotationProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'currentCreatedAt',
      'quotationByDate',
      'requestor',
      'company',
      'quotationComments',
      'detailedProductType',
      'productSize',
      'boardTypeAndPlacement',
      'quotationHandler',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'QuotationProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/vv,Afhaling,Aanpassing,Concept,Nieuw,In_behandeling/Offerte';
  }

  public getPageTitle(): string {
    return 'Nieuwe offertes';
  }

  // Override
  public getDefaultSort(): string {
    return 'quotationByDate';
  }

  // Override
  public showImportant(subProject: SubProject) {
    return subProject.quotationImportant;
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach(p => {
      p.applyGreenBackground = p.quotation ? p.quotationSent : false;
      if (
        p.project != null &&
        CollectionHelper.isPopulated(p.project.products)
      ) {
        p.project.products.forEach(prod => this.preprocessProduct(prod));
      }
    });
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }
}
